import Collapse from 'bootstrap.collapse';
import { scrollTo } from 'ui-utils';
import { fetch } from 'utils';

onLoad();

export function onLoad(context = document) {
    context.querySelectorAll('.cart-widget').forEach(cart => {
        const dropdown = new Collapse(cart.querySelector('.dropdown'), { toggle: false });

        cart.addEventListener('mouseenter', () => dropdown.show());

        cart.addEventListener('mouseleave', () => dropdown.hide());

        cart.addEventListener('removeItem', async e => {
            const response = await fetch(`/api/cart/${e.detail.id}`, {
                method: 'DELETE'
            });
            const data = await response.json();

            for (const key in data) {
                cart.$data[key] = data[key];
            }
        });

        context.querySelectorAll('.add-to-cart form, .add-bundle-to-cart form').forEach(addToCart => {
            addToCart.addEventListener('success', e => {
                for (const key in e.detail.data) {
                    cart.$data[key] = e.detail.data[key];
                }
                
                scrollTo('#app');
            });
        });
    });
}